import * as React from 'react'
import { connect } from 'react-redux'
import { Button, Grid, Header, Icon, Segment, Tab } from 'semantic-ui-react'
import MarqueeBanner from '../RollItemStore/containers/MarqueeBanner'
import { toast } from 'react-toastify'
import { homeService, itemService, userService } from '../../../../services'
import { ExchangeStoreDeck } from './ExchangeStoreDeck'
import ExchangeStorePicker from './ExchangeStorePicker'
import { ExchangeUtils } from './ExchangeUtils'
import * as _ from 'lodash'

interface IExchangeStoreProps {
    isLoggedIn: boolean,
    user: IUser,
}

interface IExchangeStoreState {
    isLoading: boolean,
    storeInfo: IStoreInfo,
    selectedItems: IIngotItemInfo[],
}

class ExchangeStore extends React.Component<IExchangeStoreProps, IExchangeStoreState> {
    state = {
        isLoading: false,
        storeInfo: {
            coin: 0,
            items: []
        },
        selectedItems: [],
    }

    componentDidMount(): void {
        this.fetchExchangeStore()
    }

    fetchExchangeStore() {
        this.setState({isLoading: true})
        itemService.getExchangeStore()
            .then(value => {
                this.setState({
                    isLoading: false,
                    storeInfo: value,
                    selectedItems: [],
                })
            }).catch(error => {
            this.setState({isLoading: false})
            toast.error(error.message)
        })
    }

    handlePickItem(item: IIngotItemInfo) {
        if (!this.props.isLoggedIn) {
            return
        }
        let {storeInfo} = this.state
        let selectedItems: IIngotItemInfo[] = this.state.selectedItems
        let availableItems: IIngotItemInfo[] = storeInfo.items
        const newNum = item.num - 1
        const newAvailableCoin = storeInfo.coin - item.value
        if (newAvailableCoin < 0) {
            toast.error('Không đủ coin để đổi, quý khách vui lòng quay lại sau! Xin cảm ơn')
            return
        }
        const indexPickingItem = availableItems.findIndex(value => value.id === item.id)
        const indexSelectedItem = selectedItems.findIndex(value => value.id === item.id)
        // add item to selected items
        if (indexSelectedItem >= 0) {
            let oldSeletedItem = selectedItems[indexSelectedItem]
            oldSeletedItem.num = oldSeletedItem.num + 1
            selectedItems[indexSelectedItem] = oldSeletedItem
        } else {
            let newSelectedItem = {...item}
            newSelectedItem.num = 1
            selectedItems.push(newSelectedItem)
        }
        // remove item from available items
        if (newNum <= 0) {
            availableItems.splice(indexPickingItem, 1)
        } else {
            item.num = newNum
            availableItems[indexPickingItem] = item
        }
        this.setState({
            storeInfo: {
                items: availableItems,
                coin: newAvailableCoin
            },
            selectedItems: selectedItems,
        })
    }

    handleRemoveItem(item: IIngotItemInfo) {
        let {storeInfo} = this.state
        let selectedItems: IIngotItemInfo[] = this.state.selectedItems
        let availableItems: IIngotItemInfo[] = storeInfo.items

        const newAvailableCoin = storeInfo.coin + item.value

        // remove item from selectedItems
        const indexSelectedItem = selectedItems.findIndex(value => value.id === item.id)
        const newNum = item.num - 1
        if (newNum <= 0) {
            selectedItems.splice(indexSelectedItem, 1)
        } else {
            item.num = newNum
            selectedItems[indexSelectedItem] = item
        }

        // add item to availableItems
        const indexAvailableItem = availableItems.findIndex(value => value.id === item.id)
        if (indexAvailableItem >= 0) {
            const oldAvailableItem = availableItems[indexAvailableItem]
            oldAvailableItem.num = oldAvailableItem.num + 1
            availableItems[indexAvailableItem] = oldAvailableItem
        } else {
            const newAvailableItem = {...item}
            newAvailableItem.num = 1
            availableItems.push(newAvailableItem)
        }

        this.setState({
            storeInfo: {
                items: availableItems,
                coin: newAvailableCoin
            },
            selectedItems: selectedItems,
        })
    }

    onClickBuyItem() {
        const {selectedItems} = this.state
        const {user} = this.props
        if (user.amount < ExchangeUtils.calculateTotalVnd(selectedItems)) {
            toast.error('Tài khoản của bạn không đủ tiền, vui lòng nạp thêm!')
            return
        }
        if (!user.steamId) {
            toast.error('Bạn chưa thiết lập thông tin steamID! ' +
                'Bạn vui lòng bổ sung thông tin steamId ở trang profile! Xin cảm ơn!')
            return
        }
        if (!selectedItems || selectedItems.length <= 0) {
            toast.error('Bạn chưa chọn item để mua!')
            return
        }
        this.setState({
            isLoading: true
        })
        userService.exchangeItem({
            items: selectedItems,
            steamId: user.steamId,
            email: user.email
        }).then(result => {
            if (result.success) {
                toast.info('Mua hàng thành công! Xin cảm ơn quý khách!')
                this.setState({
                    isLoading: false,
                })
                homeService.getAppState()
                this.fetchExchangeStore()
            } else {
                toast.error('Mua hàng không thành công!! Thông tin: ' + result.message)
                this.setState({
                    isLoading: false
                })
                homeService.getAppState()
                this.fetchExchangeStore()
            }
        }).catch(error => {
            toast.error('Đã có lỗi xảy ra khi mua hàng!' + error.message)
            this.setState({
                isLoading: false
            })
            homeService.getAppState()
            this.fetchExchangeStore()
        })
    }

    render(): JSX.Element | false | null {
        const {isLoading, storeInfo, selectedItems} = this.state
        const {user, isLoggedIn} = this.props
        const csItems = _.filter(storeInfo.items, {'appId': 730})
        const dotaItems = _.filter(storeInfo.items, {'appId': 570})
        return (
            <div>
                <MarqueeBanner/>
                <div className="container store">
                    <Segment loading={isLoading} style={{border: 'none', paddingBottom: '70px'}}>
                        <Grid columns={2} stackable={true} style={{border: 'none'}}>
                            <Grid.Column>
                                <Header as={'h3'} attached={'top'}>
                                    Chọn Item ~ Coin có sẵn:
                                    <span style={{color: 'green'}}>
                                    {storeInfo.coin.toFixed(2)}
                                </span>
                                    <Button
                                        floated={'right'}
                                        size={'mini'}
                                        color={'blue'}
                                        onClick={() => this.fetchExchangeStore()}
                                    >
                                        <Icon name="refresh"/>Tải lại
                                    </Button>
                                </Header>
                                <Tab
                                  panes={[
                                    {
                                      menuItem: 'CS-GO',
                                      render: () => (
                                        <ExchangeStoreDeck
                                          onClickItem={item => this.handlePickItem(item)}
                                          items={csItems}
                                        />)
                                    },
                                    {
                                      menuItem: 'Dota',
                                      render: () => (
                                        <ExchangeStoreDeck
                                          onClickItem={item => this.handlePickItem(item)}
                                          items={dotaItems}
                                        />)
                                    }
                                  ]}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <ExchangeStorePicker
                                    handleRemoveItem={(item) => this.handleRemoveItem(item)}
                                    onClickBuyItem={() => this.onClickBuyItem()}
                                    selectedItems={selectedItems}
                                    userInfo={user}
                                    isLoggedIn={isLoggedIn}
                                />
                            </Grid.Column>
                        </Grid>
                    </Segment>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
    ...ownProps,
    isLoggedIn: state.loggedIn,
    user: state.root.userInfo,
})

export default connect(mapStateToProps)(ExchangeStore)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/ExchangeStore/ExchangeStore.tsx